import React from "react";
import { Button, Grid } from "@mui/material";
import loginLoggo from "../../../MobileScreens/assets/images/loginLoggo.svg";

import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import corTop from "../../../MobileScreens/assets/images/corTop.png";
import corBot from "../../../MobileScreens/assets/images/corBot.png";
import { useNavigate } from "react-router-dom";

import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../../FormikControl";

function MobileLogin() {
  const navigate = useNavigate();

  const initialValues = {
    society_code: "",
    user_email: "",
    password: "",
  };

  const validationSchema = Yup.object({
    society_code: Yup.string().required("Required"),
    user_email: Yup.string().required("Required"),
    password: Yup.string().required("Required"),
  });

  const onSubmit = (values) => console.log("Form Data", values);

  return (
    <>
      <div className="loginScreenMain">
        <div className="loggTopMain">
          <img src={corTop} className="corTop" />
          <img src={loginLoggo} className="loggTopMainImgM" />
          <img src={corBot} className="corBot" />
        </div>
        <div className="logContDiv">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {(formik) => (
              <Form>
                <div className="wraperMobile">
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>
                      <h1 className="headingLogin">Owner Login</h1>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <div className="loginInptOutt">
                        <CorporateFareIcon />
                        <FormikControl
                          control="input"
                          type="text"
                          //   label="Society Code"
                          placeholder="Society Code"
                          //   labelclassName="reggistraLabel"
                          name="society_code"
                          className="loginInpt"
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <div className="loginInptOutt">
                        <MailOutlineIcon />
                        <FormikControl
                          control="input"
                          type="text"
                          //   label="Society Code"
                          placeholder="Username or Email Id"
                          //   labelclassName="reggistraLabel"
                          name="user_email"
                          className="loginInpt"
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <div className="loginInptOutt">
                        <LockOpenIcon />
                        <FormikControl
                          control="input"
                          type="password"
                          //   label="Society Code"
                          placeholder="Password"
                          //   labelclassName="reggistraLabel"
                          name="password"
                          className="loginInpt"
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <div className="remenbTx">
                        <div className="checkMeMain">
                          <FormControlLabel
                            control={<Checkbox defaultChecked />}
                            label="Remember Me"
                          />
                        </div>
                        <b onClick={() => navigate("/MobileForgotPassword")}>
                          Forgot Password
                        </b>
                      </div>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <p className="whyRem">
                        <b>Why Remember Me?</b> With this option, you won't need
                        to re-enter your email id
                      </p>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <Button
                        className="fullWidBt"
                        onClick={() => navigate("/MobileDashboard")}
                      >
                        Sign In
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
}

export default MobileLogin;
